import styled from 'styled-components';
import Ico36 from 'dc/Ico36';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Icon = styled(Ico36)`
  margin-right: 16px;
  color: ${props => (props.yourTeam ? '#00ab97' : '#90a4ae')};
`;
